 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Node} from '@tiptap/core'
import { mergeAttributes} from '@tiptap/react'

const LOOM_REGEX = /^(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/[a-zA-Z0-9]+/g

export const unfurlLoomLinks = (rawContent) => {
  if (!rawContent.content) {
    return rawContent
  }

  const newContent = []
  rawContent.content.forEach((content) => {
    if (content.type === 'paragraph') {
      newContent.push(content, ...getLoomNodesForParagraph(content))
    } else {
      newContent.push(unfurlLoomLinks(content))
    }
  })

  return {
    ...rawContent,
    content: newContent
  }
}

const getLoomNodesForParagraph = (content) => {
  const distinctLoomLinks = {}
  _optionalChain([content, 'access', _ => _.content, 'optionalAccess', _2 => _2.forEach, 'call', _3 => _3((subContent) => {
    if (subContent.type === 'text') {
      const link = _optionalChain([subContent, 'access', _4 => _4.marks, 'optionalAccess', _5 => _5.find, 'call', _6 => _6((mark) => mark.type === 'link')])
      if (!link) {
        return
      }

      if (_optionalChain([link, 'access', _7 => _7.attrs, 'optionalAccess', _8 => _8.href, 'access', _9 => _9.match, 'call', _10 => _10(LOOM_REGEX)])) {
        const linkKey = link.attrs.href.split('?')[0]
        if (!distinctLoomLinks[linkKey]) {
          distinctLoomLinks[linkKey] = link.attrs.href
        }
      }
    }
  })])

  return Object.values(distinctLoomLinks).map((link) => {
    return {
      type: 'loom',
      attrs: {
        src: link
      }
    }
  })
}

export const LoomExtension = Node.create({
  name: 'loom',

  group: 'block',
  inline: false,

  addAttributes() {
    return {
      src: {
        default: null
      }
    }
  },

  renderHTML(props) {
    const {HTMLAttributes} = props
    const components = HTMLAttributes.src.split('/')
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        style: 'position: relative; padding-bottom: 75%; height: 0; margin: 8px 0px;'
      }),
      [
        'iframe',
        {
          src: `https://www.loom.com/embed/${components[components.length - 1]}`,
          style: 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;',
          frameborder: '0',
          webkitallowfullscreen: true,
          mozallowfullscreen: true,
          allowfullscreen: true
        }
      ]
    ]
  }
})
